import { __rest } from "tslib";
import React from 'react';
import classNames from 'classnames';
import s from './modal-content-layout.module.css';
export var ModalPreview = function ModalPreview(_a) {
  var children = _a.children,
    className = _a.className,
    props = __rest(_a, ["children", "className"]);
  return React.createElement("div", Object.assign({}, props, {
    className: classNames(s.container, className)
  }), children);
};